export default __webpack_public_path__ + "static/art-wheres_waldo-59fd3f12f02855ef3905cdabac47eec3.png";